module.exports = __webpack_public_path__ + "img/a96f010.jpg";